import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cost", "currency", "monthly", "preview", "result"]
  static values = {
    eurRate: { type: Number, default: 0.92 },
    margin: { type: Number, default: 0.25 }
  }

  connect() {
    // Calculate on load if there's already a value
    if (this.hasCostTarget && this.costTarget.value) {
      this.calculate()
    }
  }

  calculate() {
    const cost = parseFloat(this.costTarget.value) || 0
    const currency = this.hasCurrencyTarget ? this.currencyTarget.value : 'USD'

    if (cost <= 0) {
      if (this.hasPreviewTarget) this.previewTarget.style.display = 'none'
      return
    }

    let eurCost
    if (currency === 'USD') {
      eurCost = cost * this.eurRateValue
    } else {
      eurCost = cost
    }

    // Apply margin: price = cost / (1 - margin)
    const price = (eurCost / (1 - this.marginValue)).toFixed(2)

    if (this.hasPreviewTarget) this.previewTarget.style.display = 'block'
    if (this.hasResultTarget) this.resultTarget.textContent = '€' + price
    if (this.hasMonthlyTarget) this.monthlyTarget.value = price
  }
}
